import { Address } from 'types';

export const getAddressURLQuery = (location: Address) => {
  return encodeURIComponent(
    `${location.address}, ${location.city}, ${location.stateAbbr} ${location.postalCode}`,
  );
};

export const getGoogleMapsRoute = (origin: Address, destination: Address) => {
  const originQuery = getAddressURLQuery(origin);
  const destinationQuery = getAddressURLQuery(destination);

  return `https://www.google.com/maps/dir/?api=1&origin=${originQuery}&destination=${destinationQuery}`;
};
